module.exports = __webpack_public_path__ + "bb138c11.svg";